export default "__VITE_ASSET__61cec4fc__"